declare var $: any;
// import * as ytp from 'yt-player';
import 'core-js/es/array';

export class AboutMoreFunctions {

  private invokeEvent: any = null;
  private currentId: string = '';

  setupLinks() {

    const links = Array.from(document.querySelectorAll('.about-more-link'));

    links.forEach((link: any) => {

      const id: string = link.id.substring(16);

      // video.removeEventListener('click', () => {
      // this.loadVideo(id);
      // });
      link.addEventListener('click', () => {
        this.loadMore(id);
      });

    });

    const imgLinks = Array.from(document.querySelectorAll('.promo-subimage'));

    imgLinks.forEach((link: any) => {

      let id: string = link.id;
      id = id.substring(10, id.lastIndexOf('-'));

      link.addEventListener('click', () => {
        this.loadImage(id, link);
      });

    });

    const modalParent = document.querySelector('#modalParent');
    if (modalParent) {
      // modalParent.removeEventListener('click', this.closeModalIfClickOutside);
      modalParent.addEventListener('click', this.closeModalIfClickOutside.bind(this));
    }

  }

  closeModalIfClickOutside(event: any) {
    const theevent = event || window.event;
    const { target: eventtarget } = theevent;
    if ($(eventtarget).hasClass('more-modal-container') ||
      $(eventtarget).hasClass('more-modal-close')) {
      $('.more-modal-dialog').removeClass('invoked');
      $('body').removeClass('noscroll');
      $('body').removeClass('modal-overlay');

      setTimeout(
        () => {
          $('.more-modal-dialog').addClass('loaded');
        },
        400,
      );

    }
  }

  loadImage(id: string, link: any) {

    const promoImg = $(`#promo-image-${id} img`);
    // $(promoImage).css('background-image', link.style.backgroundImage);
    const subImg = document.getElementById(link.id.replace('sub-image', 'sub-img'));

    if (subImg) {
      const toImage: HTMLImageElement = <HTMLImageElement>subImg;
      $(promoImg).attr('src', toImage.src);
    }
    $('.promo-subimage').removeClass('promo-subimage--selected');
    $(link).addClass('promo-subimage--selected');

    const promoImageCaption = $('.promo-image-caption');
    $(promoImageCaption).html($(link).attr('data-title'));

  }

  loadMore(id: string) {

    if (id !== 'resize') {
      this.currentId = id;
    }

    if (id !== 'resize') {
      const promoImageCaption = $('.promo-image-caption');
      $(promoImageCaption).html('');
      $('.promo-details').removeClass('promo-details--show');
      const promoDetails = $(`#promo-${this.currentId}`);
      $(promoDetails).addClass('promo-details--show');
    }

    const promoImageContainer = $(`#promo-mainimage-${this.currentId}`);

    if (id !== 'resize') {
      $(promoImageContainer).addClass('promo-mainimage--show');
    }

    const promoSubImagesContainer = $(`#promo-subimages-${this.currentId}`);

    if (id !== 'resize') {
      $(promoSubImagesContainer).addClass('promo-subimages--show');
    }

    const promoImage = $(`#promo-image-${this.currentId}`);
    const promoImg = $(`#promo-image-${this.currentId} img`);
    if (promoImage && promoImageContainer) {
      $(promoImage).width($(promoImageContainer).width());
      $(promoImage).height($(promoImage).width());
      $(promoSubImagesContainer).width($(promoImage).width());
    }

    // const mainSubImage = document.getElementById(`sub-image-${this.currentId}-1`);
    const mainSubImg = document.getElementById(`sub-img-${this.currentId}-1`);
    if (mainSubImg && id !== 'resize') {
      const toImage: HTMLImageElement = <HTMLImageElement>mainSubImg;
      // $(promoImage).css('background-image', mainSubImage.style.backgroundImage);
      $(promoImg).attr('src', toImage.src);
    }

    const promoMemberImageContainer = $(`#member-imagecontainer-${this.currentId}`);
    if (id !== 'resize') {
      $(promoMemberImageContainer).addClass('promo-memberimage--show');
    }

    const promoMemberImage = $(`#member-image-${this.currentId}`);
    if (promoMemberImage && promoMemberImageContainer) {
      $(promoMemberImage).width($(promoMemberImageContainer).width());
      $(promoMemberImage).height($(promoMemberImage).width());
    }

    $('.more-modal-content').height('auto');
    $('.more-modal-content').height($('.more-modal-content').height() >
      ($(window).height() / 100) * 85 ? ($(window).height() / 100) * 85 : 'auto');

    if (id !== 'resize') {
      $('.more-modal-dialog').addClass('invoked');
      $('body').addClass('modal-overlay');
      $('body').addClass('noscroll');
    }
  }

}
